import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=7fee0bd1"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"
import style0 from "./MainSlider.vue?vue&type=style&index=0&id=7fee0bd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports